var map = {
	"./cs.json": 4301,
	"./da.json": 6500,
	"./de.json": 1468,
	"./en-GB.json": 4004,
	"./en.json": 7707,
	"./es.json": 7735,
	"./fr-CA.json": 7339,
	"./fr.json": 4491,
	"./it.json": 7074,
	"./ja.json": 4132,
	"./ko.json": 7310,
	"./nl.json": 9510,
	"./no.json": 3634,
	"./pl.json": 3249,
	"./pt-BR.json": 4985,
	"./ru.json": 853,
	"./sv.json": 4635,
	"./zh-Hans.json": 9737,
	"./zh-Hant.json": 8151
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7497;